import { Injectable } from '@angular/core';
import { EntryNotFoundException } from '@web/common';
import { isNil } from '@web/utils';
import { Observable, of } from 'rxjs';
import { SelectItem } from '@web/shared/ui';
import { AdminBoxSaleStatus } from '../enums/admin-box-sale-status';

@Injectable({
  providedIn: 'root',
})
export class AdminBoxSaleStatusProviderService {
  private readonly entries = new Map<AdminBoxSaleStatus, string>([
    [AdminBoxSaleStatus.Approved, 'Zatwierdzony'],
    [AdminBoxSaleStatus.Archived, 'Zarchiwizowany'],
    [AdminBoxSaleStatus.Draft, 'Szkic'],
  ]);

  public labelFor(status: AdminBoxSaleStatus): Observable<string> {
    const entry = this.entries.get(status);

    if (isNil(entry)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" code is not found.`,
      );
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<AdminBoxSaleStatus>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([status, label]) => new SelectItem(label, status),
      ),
    );
  }
}
